import React from 'react'
import {
  Button,
  Card,
  CardBody
} from 'reactstrap'
import PropTypes from 'prop-types'

import PlusIcon from '../../svgs/PlusIcon'

const IntegrationCreationCard = ({ onClick, title }) => (
  <Card name="create" style={{ width: '320px', height: '200px' }}>
    <CardBody className="d-flex flex-column justify-content-center align-items-center">
      <Button
        color="link"
        onClick={(event) => onClick(event)}
        title={title}
      >
        <PlusIcon size={3} />
      </Button>
    </CardBody>
  </Card>
)

IntegrationCreationCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default IntegrationCreationCard
